export const translations = {
  en: {
    // Navbar
    nav: {
      features: 'Features',
      howItWorks: 'How It Works',
      pricing: 'Pricing',
      faq: 'FAQ',
      contactNow: 'Contact Now',
    },
    
    // Hero
    hero: {
      badge: 'Trusted by 200+ Cloud Kitchens',
      headline: 'Skyrocket Your',
      headlineHighlight: 'Zomato & Swiggy',
      headlineEnd: 'Orders with AI-Enhanced Menus',
      subheadline: 'Professional food visuals and SEO descriptions at',
      price: '₹500/Listing',
      delivery: 'Delivery ready in',
      deliveryTime: '24 hours',
      ctaPrimary: 'Contact Now',
      ctaSecondary: 'See the Magic',
      statOrders: 'More Orders',
      statTurnaround: 'Turnaround',
      statRating: 'Client Rating',
    },
    
    // Biryani Palace Card
    biryaniCard: {
      name: 'Biryani Palace',
      cuisine: 'North Indian, Biryani',
      time: '25-30 min',
      item1: 'Hyderabadi Dum Biryani',
      item1Desc: 'Aromatic basmati rice with tender chicken...',
      item2: 'Butter Chicken',
      item2Desc: 'Creamy tomato gravy with succulent...',
      ranking: '#2 in Area',
    },
    
    // Before/After Slider
    comparison: {
      label: 'The Transformation',
      title: 'See the',
      titleHighlight: 'AI Magic',
      subtitle: 'Drag the slider to see how we transform amateur phone photos into professional food photography',
      before: 'Phone Camera',
      after: 'MenuRank AI',
      instruction: '← Drag to compare →',
    },
    
    // Video Slider
    videoSlider: {
      label: 'Live Preview',
      title: 'See the',
      titleHighlight: 'Transformation',
      subtitle: 'Drag the slider to compare the original listing with our AI-enhanced version',
      before: 'Original',
      after: 'Enhanced',
      instruction: '← Drag to compare →',
    },
    
    // Features
    features: {
      label: 'Why MenuRank AI',
      title: 'Everything Your Menu Needs',
      subtitle: 'From stunning visuals to SEO-optimized descriptions — we handle it all',
      seoTitle: 'SEO Descriptions',
      seoDesc: 'We write descriptions that rank for keywords like "Best Biryani" or "Comfort Food Near Me". Get discovered first.',
      turnaroundTitle: '24h Turnaround',
      turnaroundDesc: 'Faster than booking a photographer. Upload today, publish tomorrow.',
      platformTitle: 'Platform Ready',
      platformDesc: 'Formatted specifically for Swiggy & Zomato algorithms. Perfect dimensions, every time.',
      photoTitle: 'AI Photo Enhancement',
      photoDesc: 'Color correction, steam effects, and lighting fixes that make food irresistible.',
      rankingTitle: 'Ranking Boost',
      rankingDesc: 'Our optimized menus help you climb the search results and get more visibility.',
      rankingStat: '+30% Orders',
    },
    
    // How It Works
    howItWorks: {
      label: 'Simple Process',
      title: 'How It Works',
      subtitle: 'Three simple steps to transform your menu and boost your orders',
      step1Title: 'Upload Your Menu',
      step1Desc: "Send us your current menu photos via WhatsApp. Phone photos are totally fine — that's what we're here to fix!",
      step2Title: 'AI Magic Happens',
      step2Desc: 'Our AI enhances your photos and writes SEO-optimized descriptions that Zomato & Swiggy algorithms love.',
      step3Title: 'Go Live & Rank',
      step3Desc: 'Within 24 hours, receive your polished menu ready to upload. Watch your orders climb!',
    },
    
    // Pricing
    pricing: {
      label: 'Simple Pricing',
      title: 'Transparent & Affordable',
      subtitle: 'No hidden fees. No long contracts. Pay per listing and watch your orders grow.',
      starter: 'Starter',
      starterDesc: 'Perfect for new kitchens',
      premium: 'Premium',
      premiumDesc: 'Best for established menus',
      premiumBadge: 'Most Popular',
      custom: 'Custom',
      customDesc: 'For Custom menus',
      perListing: '/Listing',
      perItem: '/item',
      menuImages: 'Menu Images',
      upTo15: 'Up to 15 Menu Images',
      upTo40: 'Up to 40 Menu Images',
      customImages: 'Custom Menu Images',
      aiEnhanced: 'AI Enhanced Images',
      premiumEnhanced: 'Premium Enhanced Images',
      basicSeo: 'Basic SEO Description',
      advancedSeo: 'Advanced SEO Description',
      delivery72: '72 Hours Delivery',
      delivery48: '48 Hours Delivery',
      whatsappSupport: 'WhatsApp Support',
      noImages: 'No Images? Contact Us',
      contactNow: 'Contact Now',
      addons: 'Add-ons',
      addonsNote: '(Available with all plans)',
      zomatoVideo: 'Zomato Listing Video',
      zomatoImage: 'Zomato Listing Image',
    },
    
    // Testimonials
    testimonials: {
      label: 'Success Stories',
      title: 'Loved by Cloud Kitchens',
      subtitle: 'See how other kitchen owners transformed their business with MenuRank AI',
      review1Name: 'Rajesh Kumar',
      review1Role: 'Owner, Spice Box Kitchen',
      review1Quote: 'Our orders jumped 35% within the first week! The AI descriptions are so good, customers say our food looks exactly like the photos now.',
      review1Stat: '+35% Orders',
      review2Name: 'Priya Sharma',
      review2Role: "Founder, Mom's Kitchen Cloud",
      review2Quote: 'I was spending ₹5000 on photographers. MenuRank AI gave me better results for ₹500. The ROI is insane.',
      review2Stat: '90% Cost Saved',
      review3Name: 'Amit Patel',
      review3Role: 'CEO, Biryani Bros (3 outlets)',
      review3Quote: 'We rank #2 for "Best Biryani" in our area now. The SEO descriptions actually work. Best investment for our cloud kitchen.',
      review3Stat: '#2 Ranking',
    },
    
    // FAQ
    faq: {
      label: 'Got Questions?',
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about MenuRank AI',
      q1: "I don't have any food images yet. Can you still help?",
      a1: "Don't worry, we've got you covered! We have alternative solutions for kitchens without photos. Just message us on WhatsApp, and we'll get it sorted for you immediately.",
      q2: 'What do I need to send you?',
      a2: "Just send us your current menu photos via WhatsApp — even phone photos are fine! Include dish names and brief descriptions. We'll handle the rest.",
      q3: 'How does the AI enhancement work?',
      a3: 'Our AI analyzes your food photos and applies professional-grade corrections: color balancing, lighting enhancement, steam/heat effects, and background optimization. The result looks like it was shot by a professional food photographer.',
      q4: 'What makes your SEO descriptions different?',
      a4: 'We research trending keywords on Zomato & Swiggy for your cuisine type and location. Each description is crafted to include high-search-volume terms like "best biryani," "comfort food," or "late night delivery" naturally.',
      q5: 'Will this actually increase my orders?',
      a5: "Our clients see an average 30% increase in orders within the first month. Better photos mean higher click-through rates, and SEO descriptions mean you show up in more searches. It's a proven formula.",
      q6: 'Can I make changes after delivery?',
      a6: "Absolutely! We offer one round of revisions included in all plans. Just let us know what you'd like adjusted, and we'll get it done within 24 hours.",
      q7: 'Do you work with all delivery platforms?',
      a7: 'Yes! While we optimize primarily for Zomato and Swiggy, our photos and descriptions work great on Dunzo, Uber Eats, and even your own website or social media.',
    },
    
    // Footer
    footer: {
      tagline: "Made with love for India's Cloud Kitchens",
      whatsapp: 'WhatsApp',
      email: 'Email',
      terms: 'Terms & Conditions',
    },
  },
  
  hi: {
    // Navbar
    nav: {
      features: 'विशेषताएं',
      howItWorks: 'कैसे काम करता है',
      pricing: 'मूल्य',
      faq: 'सवाल-जवाब',
      contactNow: 'संपर्क करें',
    },
    
    // Hero
    hero: {
      badge: '200+ क्लाउड किचन द्वारा विश्वसनीय',
      headline: 'अपने',
      headlineHighlight: 'Zomato और Swiggy',
      headlineEnd: 'ऑर्डर्स को AI-Enhanced मेन्यू से बढ़ाएं',
      subheadline: 'प्रोफेशनल फूड विजुअल्स और SEO डिस्क्रिप्शन सिर्फ',
      price: '₹500/लिस्टिंग',
      delivery: 'डिलीवरी तैयार',
      deliveryTime: '24 घंटे में',
      ctaPrimary: 'संपर्क करें',
      ctaSecondary: 'जादू देखें',
      statOrders: 'ज्यादा ऑर्डर',
      statTurnaround: 'टर्नअराउंड',
      statRating: 'क्लाइंट रेटिंग',
    },
    
    // Biryani Palace Card
    biryaniCard: {
      name: 'बिरयानी पैलेस',
      cuisine: 'नॉर्थ इंडियन, बिरयानी',
      time: '25-30 मिनट',
      item1: 'हैदराबादी दम बिरयानी',
      item1Desc: 'खुशबूदार बासमती चावल टेंडर चिकन के साथ...',
      item2: 'बटर चिकन',
      item2Desc: 'क्रीमी टमाटर ग्रेवी रसीले चिकन के साथ...',
      ranking: 'एरिया में #2',
    },
    
    // Before/After Slider
    comparison: {
      label: 'ट्रांसफॉर्मेशन',
      title: 'देखें',
      titleHighlight: 'AI का जादू',
      subtitle: 'स्लाइडर को खींचकर देखें कि हम साधारण फोन फोटो को प्रोफेशनल फूड फोटोग्राफी में कैसे बदलते हैं',
      before: 'फोन कैमरा',
      after: 'MenuRank AI',
      instruction: '← तुलना के लिए खींचें →',
    },
    
    // Video Slider
    videoSlider: {
      label: 'लाइव प्रीव्यू',
      title: 'देखें',
      titleHighlight: 'ट्रांसफॉर्मेशन',
      subtitle: 'ओरिजिनल लिस्टिंग और AI-enhanced वर्जन की तुलना के लिए स्लाइडर खींचें',
      before: 'ओरिजिनल',
      after: 'एन्हैंस्ड',
      instruction: '← तुलना के लिए खींचें →',
    },
    
    // Features
    features: {
      label: 'MenuRank AI क्यों',
      title: 'आपके मेन्यू के लिए सब कुछ',
      subtitle: 'शानदार विजुअल्स से SEO-ऑप्टिमाइज्ड डिस्क्रिप्शन तक — हम सब संभालते हैं',
      seoTitle: 'SEO डिस्क्रिप्शन',
      seoDesc: 'हम ऐसे डिस्क्रिप्शन लिखते हैं जो "बेस्ट बिरयानी" या "कम्फर्ट फूड" जैसे कीवर्ड पर रैंक करें। पहले खोजे जाएं।',
      turnaroundTitle: '24 घंटे में',
      turnaroundDesc: 'फोटोग्राफर बुक करने से तेज। आज अपलोड करें, कल पब्लिश करें।',
      platformTitle: 'प्लेटफॉर्म रेडी',
      platformDesc: 'Swiggy और Zomato एल्गोरिदम के लिए विशेष रूप से फॉर्मेटेड। हर बार परफेक्ट डाइमेंशन।',
      photoTitle: 'AI फोटो एन्हांसमेंट',
      photoDesc: 'कलर करेक्शन, स्टीम इफेक्ट्स, और लाइटिंग फिक्स जो खाने को अनूठा बनाते हैं।',
      rankingTitle: 'रैंकिंग बूस्ट',
      rankingDesc: 'हमारे ऑप्टिमाइज्ड मेन्यू आपको सर्च रिजल्ट्स में ऊपर ले जाते हैं।',
      rankingStat: '+30% ऑर्डर',
    },
    
    // How It Works
    howItWorks: {
      label: 'सरल प्रक्रिया',
      title: 'कैसे काम करता है',
      subtitle: 'अपने मेन्यू को बदलने और ऑर्डर बढ़ाने के तीन सरल कदम',
      step1Title: 'मेन्यू अपलोड करें',
      step1Desc: 'WhatsApp पर अपनी मौजूदा मेन्यू फोटो भेजें। फोन फोटो भी चलेंगे — यही तो हम ठीक करते हैं!',
      step2Title: 'AI का जादू',
      step2Desc: 'हमारा AI आपकी फोटो को एन्हांस करता है और SEO-ऑप्टिमाइज्ड डिस्क्रिप्शन लिखता है जो Zomato और Swiggy एल्गोरिदम को पसंद आते हैं।',
      step3Title: 'लाइव करें और रैंक करें',
      step3Desc: '24 घंटे में, अपना पॉलिश्ड मेन्यू प्राप्त करें जो अपलोड के लिए तैयार है। अपने ऑर्डर बढ़ते देखें!',
    },
    
    // Pricing
    pricing: {
      label: 'सरल मूल्य',
      title: 'पारदर्शी और किफायती',
      subtitle: 'कोई छिपी फीस नहीं। कोई लंबे कॉन्ट्रैक्ट नहीं। प्रति लिस्टिंग भुगतान करें और ऑर्डर बढ़ते देखें।',
      starter: 'स्टार्टर',
      starterDesc: 'नए किचन के लिए परफेक्ट',
      premium: 'प्रीमियम',
      premiumDesc: 'स्थापित मेन्यू के लिए बेस्ट',
      premiumBadge: 'सबसे लोकप्रिय',
      custom: 'कस्टम',
      customDesc: 'बड़े मेन्यू के लिए',
      perListing: '/लिस्टिंग',
      perItem: '/आइटम',
      menuImages: 'मेन्यू इमेज',
      upTo15: '15 मेन्यू इमेज तक',
      upTo40: '40 मेन्यू इमेज तक',
      customImages: 'कस्टम मेन्यू इमेज',
      aiEnhanced: 'AI एन्हांस्ड इमेज',
      premiumEnhanced: 'प्रीमियम एन्हांस्ड इमेज',
      basicSeo: 'बेसिक SEO डिस्क्रिप्शन',
      advancedSeo: 'एडवांस्ड SEO डिस्क्रिप्शन',
      delivery72: '72 घंटे डिलीवरी',
      delivery48: '48 घंटे डिलीवरी',
      whatsappSupport: 'WhatsApp सपोर्ट',
      noImages: 'इमेज नहीं? संपर्क करें',
      contactNow: 'संपर्क करें',
      addons: 'ऐड-ऑन',
      addonsNote: '(सभी प्लान के साथ उपलब्ध)',
      zomatoVideo: 'Zomato लिस्टिंग वीडियो',
      zomatoImage: 'Zomato लिस्टिंग इमेज',
    },
    
    // Testimonials
    testimonials: {
      label: 'सफलता की कहानियां',
      title: 'क्लाउड किचन द्वारा पसंद',
      subtitle: 'देखें कैसे अन्य किचन मालिकों ने MenuRank AI से अपना बिजनेस बदला',
      review1Name: 'राजेश कुमार',
      review1Role: 'मालिक, स्पाइस बॉक्स किचन',
      review1Quote: 'पहले हफ्ते में ही हमारे ऑर्डर 35% बढ़ गए! AI डिस्क्रिप्शन इतने अच्छे हैं कि कस्टमर कहते हैं खाना बिल्कुल फोटो जैसा दिखता है।',
      review1Stat: '+35% ऑर्डर',
      review2Name: 'प्रिया शर्मा',
      review2Role: 'संस्थापक, मॉम्स किचन क्लाउड',
      review2Quote: 'मैं फोटोग्राफर पर ₹5000 खर्च करती थी। MenuRank AI ने ₹500 में बेहतर रिजल्ट दिए। ROI जबरदस्त है।',
      review2Stat: '90% बचत',
      review3Name: 'अमित पटेल',
      review3Role: 'CEO, बिरयानी ब्रोस (3 आउटलेट)',
      review3Quote: 'अब हम अपने एरिया में "बेस्ट बिरयानी" के लिए #2 पर रैंक करते हैं। SEO डिस्क्रिप्शन सच में काम करते हैं।',
      review3Stat: '#2 रैंकिंग',
    },
    
    // FAQ
    faq: {
      label: 'सवाल हैं?',
      title: 'अक्सर पूछे जाने वाले सवाल',
      subtitle: 'MenuRank AI के बारे में सब कुछ जो आपको जानना चाहिए',
      q1: 'मेरे पास फूड इमेज नहीं हैं। क्या आप मदद कर सकते हैं?',
      a1: 'चिंता न करें, हम आपकी मदद करेंगे! बिना फोटो वाले किचन के लिए हमारे पास वैकल्पिक समाधान हैं। बस WhatsApp पर मैसेज करें, हम तुरंत सुलझा देंगे।',
      q2: 'मुझे क्या भेजना होगा?',
      a2: 'बस WhatsApp पर अपनी मौजूदा मेन्यू फोटो भेजें — फोन फोटो भी चलेंगे! डिश के नाम और संक्षिप्त विवरण शामिल करें। बाकी हम संभाल लेंगे।',
      q3: 'AI एन्हांसमेंट कैसे काम करता है?',
      a3: 'हमारा AI आपकी फूड फोटो का विश्लेषण करता है और प्रोफेशनल-ग्रेड करेक्शन लागू करता है: कलर बैलेंसिंग, लाइटिंग एन्हांसमेंट, स्टीम/हीट इफेक्ट्स, और बैकग्राउंड ऑप्टिमाइजेशन।',
      q4: 'आपके SEO डिस्क्रिप्शन अलग कैसे हैं?',
      a4: 'हम आपके क्यूजीन टाइप और लोकेशन के लिए Zomato और Swiggy पर ट्रेंडिंग कीवर्ड्स रिसर्च करते हैं। हर डिस्क्रिप्शन में "बेस्ट बिरयानी," "कम्फर्ट फूड" जैसे हाई-सर्च-वॉल्यूम टर्म्स नेचुरली शामिल होते हैं।',
      q5: 'क्या इससे सच में ऑर्डर बढ़ेंगे?',
      a5: 'हमारे क्लाइंट्स पहले महीने में औसतन 30% ऑर्डर बढ़ते देखते हैं। बेहतर फोटो का मतलब ज्यादा क्लिक-थ्रू रेट, और SEO डिस्क्रिप्शन का मतलब ज्यादा सर्च में दिखना।',
      q6: 'क्या डिलीवरी के बाद बदलाव हो सकते हैं?',
      a6: 'बिल्कुल! सभी प्लान में एक राउंड ऑफ रिवीजन शामिल है। बस बताएं क्या बदलना है, और हम 24 घंटे में कर देंगे।',
      q7: 'क्या आप सभी डिलीवरी प्लेटफॉर्म के साथ काम करते हैं?',
      a7: 'हां! हम मुख्य रूप से Zomato और Swiggy के लिए ऑप्टिमाइज करते हैं, लेकिन हमारी फोटो और डिस्क्रिप्शन Dunzo, Uber Eats, और आपकी वेबसाइट या सोशल मीडिया पर भी बढ़िया काम करती हैं।',
    },
    
    // Footer
    footer: {
      tagline: 'भारत के क्लाउड किचन के लिए प्यार से बनाया',
      whatsapp: 'WhatsApp',
      email: 'ईमेल',
      terms: 'नियम और शर्तें',
    },
  },
};
